var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-9 c-content-main"},[_c('personal-info'),(_vm.$store.state.user.role === 'owner')?_c('company-info'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }